(() => {
  const SELECTOR = 'select.zalify-select';
  const CHEVRON = '<svg class="zalify-select__chevron" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  let openWrapper = null;

  const closeOpen = () => {
    if (openWrapper) {
      openWrapper.classList.remove('is-open');
      openWrapper.querySelector('.zalify-select__panel').hidden = true;
      openWrapper = null;
    }
  };

  const enhance = (select) => {
    if (select.dataset.zalifyEnhanced === '1') return;
    select.dataset.zalifyEnhanced = '1';

    const wrapper = document.createElement('div');
    wrapper.className = 'zalify-select';
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    select.classList.add('zalify-select__native');

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'zalify-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    const valueEl = document.createElement('span');
    valueEl.className = 'zalify-select__value';
    trigger.appendChild(valueEl);
    trigger.insertAdjacentHTML('beforeend', CHEVRON);

    const panel = document.createElement('ul');
    panel.className = 'zalify-select__panel';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;

    Array.from(select.options).forEach((opt) => {
      if (opt.value === '') return;
      const item = document.createElement('li');
      item.className = 'zalify-select__item';
      item.setAttribute('role', 'option');
      item.dataset.value = opt.value;
      item.textContent = opt.textContent || opt.value;
      item.addEventListener('click', () => {
        if (select.value === opt.value) {
          closeOpen();
          return;
        }
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
        closeOpen();
      });
      panel.appendChild(item);
    });

    wrapper.appendChild(trigger);
    wrapper.appendChild(panel);

    const sync = () => {
      const opt = select.options[select.selectedIndex];
      const text = opt ? (opt.textContent || opt.value) : '';
      valueEl.textContent = text;
      valueEl.classList.toggle('is-placeholder', !opt || opt.value === '');
      panel.querySelectorAll('.zalify-select__item').forEach((el) => {
        const isSelected = el.dataset.value === select.value;
        el.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    };

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const willOpen = panel.hidden;
      closeOpen();
      if (willOpen) {
        panel.hidden = false;
        wrapper.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        openWrapper = wrapper;
      }
    });

    select.addEventListener('change', sync);

    sync();
  };

  document.addEventListener('click', closeOpen);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeOpen();
  });

  const enhanceAll = () => {
    document.querySelectorAll(SELECTOR).forEach(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }

  // Re-enhance after Shopify section reloads (theme editor)
  document.addEventListener('shopify:section:load', enhanceAll);
})();
